import { render } from "./ResetPasswordWithPhone.vue?vue&type=template&id=52064a1d&scoped=true"
import script from "./ResetPasswordWithPhone.vue?vue&type=script&lang=js"
export * from "./ResetPasswordWithPhone.vue?vue&type=script&lang=js"

import "./ResetPasswordWithPhone.vue?vue&type=style&index=0&id=52064a1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52064a1d"]])

export default __exports__